export default {
    remote_readiness_labels: {
        'has_computer': 'Has a computer',
        'min_internet_connection': 'High speed internet',
        'video_conference_access': 'Able to do video conferencing',
        'focus_work_at_home': 'Able to focus at home',
        'comfortable_chair_table': 'Has a comfortable desk and chair',
        'quiet_work_space': 'Has a quiet space at home'
    },

    calculateRemoteReadiness(remoteReadiness) {
        let passed = Object.values(remoteReadiness).filter((item) => {
            return item === true || item === 1;
        });

        return passed.length;
    },

    getRemoteReadinessLabels(remoteReadiness) {
        const keys = Object.keys(remoteReadiness);
        let response = [];

        Object.values(remoteReadiness).forEach((item, key) => {
           response.push({
               title: this.remote_readiness_labels[keys[key]],
               passed: item === 1 || item === true
           });
        });

        return response;
    }
}
